import Vue from 'vue'
import Router from 'vue-router'
import hljs from 'highlight.js'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

Vue.use(Router)

function load(component) {
  return resolve => require([`../pages/${component}.md`], resolve)
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: load('introduction'),
    redirect: '/introduction'
  },
  {
    path: '/changelog',
    name: 'changelog',
    component: load('changelog')
  },
  {
    path: '/introduction',
    name: 'introduction',
    component: load('introduction'),
    meta: { title: '介绍' }
  },
  {
    path: '/guide',
    name: 'guide',
    component: load('guide'),
    meta: { title: '起步' }
  },
  {
    path: '/i18n',
    name: 'i18n',
    component: load('i18n'),
    meta: { title: '国际化' }
  },
  {
    path: '/button',
    name: 'button',
    component: load('button'),
    meta: { title: 'Button 按钮' }
  },
  {
    path: '/dialog',
    name: 'dialog',
    component: load('dialog'),
    meta: { title: 'Dialog 模态框' }
  },
  {
    path: '/select',
    name: 'select',
    component: load('select'),
    meta: { title: 'Select 下拉框' }
  },
  {
    path: '/datePicker',
    name: 'datePicker',
    component: load('datePicker'),
    meta: { title: 'Date 日期选择器' }
  },
  {
    path: '/treeSelect',
    name: 'treeSelect',
    component: load('treeSelect'),
    meta: { title: 'TreeSelect 下拉树选择' }
  },
  {
    path: '/tableFilter',
    name: 'tableFilter',
    component: load('tableFilter'),
    meta: { title: 'TableFilter 搜索条件' }
  },
  {
    path: '/table',
    name: 'table',
    component: load('table'),
    meta: { title: 'Table 表格' }
  },
  {
    path: '/link',
    name: 'link',
    component: load('link'),
    meta: { title: 'Link 文字链接' }
  },
  {
    path: '/apexNavigator',
    name: 'apexNavigator',
    component: load('apexNavigator'),
    meta: { title: 'Apex Navigator' }
  }
  // {
  //   path: '/form',
  //   name: 'form',
  //   component: load('form'),
  //   meta: { title: 'Form 表单' }
  // }
]

const router = new Router({
  // mode: 'history', // 需要nginx配置 解决刷新404
  // scrollBehavior: () => ({ y: 0 }),
  mode: 'hash',
  base: __dirname,
  routes: routes
})

NProgress.configure({ showSpinner: false }) // NProgress 配置

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  Vue.nextTick(() => {
    // 示例代码高亮
    const blocks = document.querySelectorAll('pre code:not(.hljs)')
    Array.prototype.forEach.call(blocks, hljs.highlightBlock)
  })
  NProgress.done()
})

export default router
